export const OVERLAY_LOADING = 'OVERLAY_LOADING'
export const OVERLAY_TRANSPARENT_LOADING = 'OVERLAY_TRANSPARENT_LOADING'
export const OVERLAY_ERROR = 'OVERLAY_ERROR'
export const OVERLAY_PAGE_NOT_FOUND = 'OVERLAY_PAGE_NOT_FOUND'
export const OVERLAY_UNAUTHORIZED = 'OVERLAY_UNAUTHORIZED'
